const flow = document.querySelector('[data-problemloeser-flow]');

if (flow) {
  const containers = flow.querySelectorAll('[data-problemloeser-state]');

  function currentStateKey() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('o')) return `o-${params.get('o')}`;
    if (params.get('q')) return `q-${params.get('q')}`;
    return 'landing';
  }

  function showState() {
    const key = currentStateKey();
    let matched = null;
    containers.forEach((el) => {
      const isMatch = el.getAttribute('data-problemloeser-state') === key;
      el.hidden = !isMatch;
      if (isMatch) matched = el;
    });
    if (!matched) {
      // Unknown param → fall back to landing
      const landing = flow.querySelector('[data-problemloeser-state="landing"]');
      if (landing) landing.hidden = false;
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  showState();

  window.addEventListener('popstate', showState);

  flow.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="?"]');
    if (!link) return;
    event.preventDefault();
    const newUrl = new URL(link.getAttribute('href'), window.location.href);
    history.pushState(null, '', newUrl);
    showState();
  });
}
